import "./style.css";
import { useTranslation } from "../../i18n/LanguageContext";

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    return (
        <div className="main-content-wrapper">
            <div className="PrivacyPolicyPage">
                <h2>{t("legal.privacy")}</h2>
                <p>{t("legal.updated")}</p>
                <p>{t("privacy.intro")}</p>
                {t("privacy.sections").map((s, i) => (
                    <div key={i}>
                        <h4>{s.h}</h4>
                        <p>{s.t}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PrivacyPolicy;
